import type { SxProps, Theme } from '@mui/material/styles';

/** Secondary buttons: the bordered `.app-btn` look (neutral border, card background, blue on hover). */
export const SECONDARY_BUTTON_SX: SxProps<Theme> = {
  borderColor: 'var(--border-color)',
  color: 'var(--text-primary)',
  bgcolor: 'var(--card-bg)',
  '&:hover': { borderColor: 'var(--primary-blue)', bgcolor: 'var(--primary-blue-tint)' },
};
